<template>
  <el-dialog
    :title="form.id ? '编辑日程' : '新建日程'"
    :visible.sync="dialogVisible"
    width="900px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
  >
    <el-form :model="form" :rules="rule" ref="formRef">
      <el-form-item
        label="日期"
        :label-width="formLabelWidth"
      >
          <el-date-picker
            v-model="form.date"
            value-format='yyyy-MM-dd'
            type="date"
            placeholder="选择日期">
          </el-date-picker>
      </el-form-item>

      <el-form-item
        label="日期类型"
        :label-width="formLabelWidth"
        prop="scheduleType"
      >
        <el-radio-group v-model='form.scheduleType'>
          <el-radio  v-for="(item,idx) in dateType" :label="item.value" :key='idx'>{{item.label}}</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="题目" :label-width="formLabelWidth">
        <el-input
          v-model="form.title"
          autocomplete="off"
          maxLength='200'
        ></el-input>
      </el-form-item>

      <el-form-item label="主讲人" :label-width="formLabelWidth" >
        <el-input
          type='textarea'
          v-model="form.speaker"
          maxLength='500'
          autocomplete="off"
        ></el-input>
      </el-form-item>

      <el-form-item label="简介" :label-width="formLabelWidth">
        <el-input
          type='textarea'
          maxLength='500'
          v-model="form.introduce"
        ></el-input>
      </el-form-item>

      <el-form-item label="图片" :label-width="formLabelWidth">
        <!-- <Upload v-model="form.pictureUrl"></Upload> -->
        <upload
          :list="[]"
          @childByValue="getPic">
        </upload>
        <img
              class="pic"
              v-if="form.pictureUrl"
              :src="form.pictureUrl">
      </el-form-item>

      <el-form-item label="时间" :label-width="formLabelWidth" class="w400">
         <el-time-picker
          value-format='HH:mm:ss'
          v-model="form.startTime"
          placeholder="任意时间点">
        </el-time-picker>
      </el-form-item>
      <el-form-item label="" :label-width="formLabelWidth" class='w310'>
        <span class="center-text">起至</span>
        <el-time-picker
          value-format='HH:mm:ss'
          v-model="form.endTime"
          placeholder="任意时间点">
        </el-time-picker>
        <span>止</span>
      </el-form-item>

      <el-form-item label="可获得" :label-width="formLabelWidth" class="w220 db" >
        <el-input
          v-model="form.period"
          autocomplete="off"
        ></el-input>
        <span class="xs">学时</span>
      </el-form-item>
      <div v-for="(domain, index) in form.personJson" :key="index">
        <el-form-item label="工作人员" :label-width="formLabelWidth" class="w220">
          <el-input
            v-model="domain.name"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话" label-width="80px" class="w220">
          <el-input
            v-model="domain.phone"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="负责内容" label-width="80px" class="w220">
          <el-input
            v-model="domain.job"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-button @click.prevent="removeDomain(domain)">删除</el-button>
        <el-button @click.prevent="addDomain(domain)">新增</el-button>
      </div>

      <el-form-item label="备注" :label-width="formLabelWidth" >
        <el-input
          type='textarea'
          maxLength='500'
          v-model="form.remarks"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="sure">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import Upload from '@/components/uploadCopy'
import { addClassSchedule,updateClassSchedule } from '@/api/api'


export default {
  components: {
    Upload
  },
  data() {
    return {
      dialogVisible: false,
      formLabelWidth: "130px",
      dateType:[
        {
          label:'课程',
          value:'1'
        },
        {
          label:'实训',
          value:'2'
        },
        {
          label:'考察',
          value:'3'
        },
        {
          label:'开班典礼',
          value:'4'
        },
        {
          label:'结业典礼',
          value:'5'
        },
        {
          label:'用餐',
          value:'6'
        },
      ],
      form: {
        pictureUrl: '',
        personJson:[
          {}
        ]
      },
      rule: {
        scheduleType: [
          { required: true, message: "请选择日期类型", trigger: "blur" },
        ],
      },
    };
  },
  props: {
    editParams: {
      type: Object,
      default: function(){
        return {}
      }
    }
  },
  methods: {
    setOpacity(flg) {
      this.dialogVisible = flg;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    removeDomain(item){
       var index = this.form.personJson.indexOf(item)
        if (index !== -1) {
          this.form.personJson.splice(index, 1)
        }
    },
    // 上传图片
    getPic(file) {
      console.log(file);
      this.form['pictureUrl'] = file.url;
      // this.$forceUpdate()
    },
    addDomain(){
        this.form.personJson.push({
          value: '',
          key: Date.now()
        });
    },
    sure(){
      console.log(this.editParams)
      this.$refs.formRef.validate((valid) => {
        if (valid) {
            let formCopy = JSON.parse(JSON.stringify(this.form));
            console.log(formCopy.personJson)
            if( formCopy.personJson && Object.keys(formCopy.personJson[0]).length > 0 ){
              let string = JSON.stringify(formCopy.personJson)
              formCopy.personJson = encodeURI(string)
            }else{
              delete formCopy.personJson
            }
            if( formCopy.id ){
              updateClassSchedule(formCopy).then(res => {
                let { code, message } = res;
                if (code === 0) {
                  this.$message.success('成功');
                  this.$emit('success');
                  this.handleClose()
                  this.form = {}
                } else {
                  this.$message.error(message);
                }
              })
            }else{
              addClassSchedule({
                ...formCopy,
                classId:this.editParams.classId,
                name:this.editParams.name,
              }).then(res => {
                let { code, message } = res;
                if (code === 0) {
                  this.$message.success('成功');
                  this.$emit('success');
                  this.handleClose()
                  this.form = {}
                } else {
                  this.$message.error(message);
                }
              })
            }
        }else{
            
          }
        })
    }
  },
  watch: {
    editParams: {
      immediate: true,
      handler(newValue, oldValue) {
        if( newValue && newValue.personJson ){
          newValue.personJson = JSON.parse(decodeURI(newValue.personJson))
        }
        this.form = newValue ? JSON.parse(JSON.stringify({...newValue})) : {}
      },
    },
  },
};
</script>

<style lang="scss">
.w50{
  width: 50%;
  display: inline-block;
}
.w300{
  width: 300px;
}
.w220{
  width: 220px;
  display: inline-block;
}
.w400{
  width:400px;
  display:inline-block
}
.w310{
  width:310px;
  display:inline-block;
  .center-text{
    margin-left: -20px;
    margin-right: 20px;
  }
  .el-form-item__content{
    margin-left: 0!important;
  }
}
.db{
  display: block;
}
.xs{
  position: absolute;
  right: -50px;
}
.el-dialog__body{
  // max-height: 50vh;
  overflow-y: auto;
}
</style>
